import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getMultiSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (essentialDocs, selectedIds, initialIds) => {
    let newErrors = {};

    if (selectedIds?.length < 1) {
        newErrors = {
            ...newErrors,
            documentTypes: { error: true, message: getMultiSelectMessage('document type') }
        };
    } else if (essentialDocs && essentialDocs.length > 0) {
        newErrors = { appointmentTypes: [] };
        essentialDocs.forEach((el) => {
            if (!selectedIds?.includes(el.id)) {
                newErrors = {
                    ...newErrors,
                    appointmentTypes: [
                        ...newErrors.appointmentTypes,
                        {
                            id: el.id,
                            error: true,
                            message: `${el.name} is an Appointment Type and must have a corresponding Document Type.`
                        }
                    ]
                };
            }
        });
        if (!newErrors.appointmentTypes.length) newErrors = {};
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(selectedIds, initialIds);

    return newErrors;
};
